module.exports = __webpack_public_path__ + "files/fac81293480e4f9d78a70170fbf4a247.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Droid-Serif-regular.ttf
 ** module id = 849
 ** module chunks = 0
 **/